export class PathFunctions {
  public static join(...args: string[]) {
    const parts = args.map((arg) => arg.replace(/^(.+?)\/*?$/, '$1'));
    return parts.join('/');
  }
}
